"use strict";
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var Storage_1 = require("./Storage");
exports.StorageClass = Storage_1.default;
var core_1 = require("@aws-amplify/core");
var logger = new core_1.ConsoleLogger('Storage');
var _instance = null;
if (!_instance) {
    logger.debug('Create Storage Instance');
    _instance = new Storage_1.default();
    _instance.vault = new Storage_1.default();
    _instance.vault.configure({ level: 'private' });
    var old_configure_1 = _instance.configure;
    _instance.configure = function (options) {
        logger.debug('configure called');
        old_configure_1.call(_instance, options);
        var vault_options = Object.assign({}, options, { level: 'private' });
        _instance.vault.configure(vault_options);
    };
}
var Storage = _instance;
core_1.default.register(Storage);
exports.default = Storage;
__export(require("./Providers"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/@aws-amplify/storage/lib/index.js
// module id = 579
// module chunks = 0